import {
  IonSkeletonText,
  IonHeader,
  IonToolbar,
  IonContent,
  IonItem,
} from "@ionic/react";
import React from "react";

const Skeleton__OptionsGrid: React.FC = () => {
  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Header Skeleton */}
      <IonHeader className="ion-no-border">
        <div style={{ padding: "12px 16px" }}>
          {/* Label: Underlying Future */}
          <IonSkeletonText
            animated
            style={{ width: "30%", height: "14px", marginBottom: "8px" }}
          />

          {/* Underlying Future Accordion Box */}
          <div
            style={{
              height: "48px",
              width: "100%",
              background: "var(--ion-color-step-100, #1e1e1e)",
              borderRadius: "4px",
              marginBottom: "16px",
            }}
          >
            <IonSkeletonText
              animated
              style={{ width: "90%", height: "20px", margin: "14px auto" }}
            />
          </div>

          {/* Segment Toggle (Calls/Puts) */}
          <div
            style={{
              display: "flex",
              gap: "2px",
              background: "rgba(255,255,255,0.05)",
              borderRadius: "8px",
              padding: "2px",
            }}
          >
            <IonSkeletonText
              animated
              style={{ width: "50%", height: "32px", borderRadius: "6px" }}
            />
            <IonSkeletonText
              animated
              style={{ width: "50%", height: "32px", borderRadius: "6px" }}
            />
          </div>
        </div>

        {/* Table Headings Placeholder */}
        <IonItem
          lines="none"
          style={{ "--min-height": "40px", "--background": "transparent" }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              padding: "0 8px",
            }}
          >
            {[1, 2, 3, 4, 5].map((i) => (
              <IonSkeletonText
                key={i}
                animated
                style={{ width: "15%", height: "10px" }}
              />
            ))}
          </div>
        </IonItem>
      </IonHeader>

      {/* List Content Skeleton */}
      <IonContent>
        <div style={{ padding: "0 8px" }}>
          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "60px",
                borderBottom: "1px solid rgba(255,255,255,0.05)",
              }}
            >
              <IonSkeletonText
                animated
                style={{ width: "15%", height: "20px" }}
              />
              <IonSkeletonText
                animated
                style={{ width: "15%", height: "20px" }}
              />
              <IonSkeletonText
                animated
                style={{ width: "15%", height: "20px" }}
              />
              <IonSkeletonText
                animated
                style={{ width: "15%", height: "20px" }}
              />
              <IonSkeletonText
                animated
                style={{ width: "15%", height: "20px" }}
              />
            </div>
          ))}
        </div>
      </IonContent>
    </div>
  );
};

export default Skeleton__OptionsGrid;
